export const EConfigurationTemplateValues = {
	name: 'name',
	type: 'type',
	date: 'date',
	time: 'time',
	notes: 'notes',
	networkElement: 'networkElement',
	validationRulesFolderName: 'validationRulesFolderName',
	validationRulesFolderId: 'validationRulesFolderId',
} as const;

export const clonedTemplateNameError = 'Template name should be different from the original one';
